import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useCatalogElementsQuery } from "./hooks/queries/useCatalogElementsQuery";
import { useRealtimeInvalidation } from "@/pages/laboratory/hooks/queries/useRealtimeInvalidation";
import { TableElement } from "./components/TableElement";

export const CatalogElementPage = () => {
  const { elementId } = useParams();
  const { data: elements, isLoading, error } = useCatalogElementsQuery();
  const [errorMessage, setErrorMessage] = useState("");

  useRealtimeInvalidation();

  return (
    <>
      <HelmetDexteel title={"Elements"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableElement
              elementId={elementId}
              elements={elements ?? null}
              isLoading={isLoading}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal
        error={error?.message || errorMessage}
        onHide={() => setErrorMessage("")}
      />
    </>
  );
};
